// extracted by mini-css-extract-plugin
export default {"Container":"ErrorPasswordExceeded_Container__Opdqo","profileIcon":"ErrorPasswordExceeded_profileIcon__UpHWB","paraWrapper":"ErrorPasswordExceeded_paraWrapper__Gte-I"};